<!-- src/app/pages/compare/compare.component.html -->
<section class="compare-page">
  <div class="container">

    <div class="hero">
      <h1>Compare the Candidates</h1>
      <p class="hero-sub">
        See where Lydia Christensen stands on the issues - and how she compares to the field.
        Only one candidate is truly outside the two-party establishment.
      </p>
    </div>

    <div class="legend">
      <span class="legend-item"><span class="dot dot--lydia"></span> Lydia Christensen (Libertarian)</span>
      <span class="legend-item"><span class="dot dot--dem"></span> Democrat candidates</span>
      <span class="legend-item"><span class="dot dot--rep"></span> Republican candidate</span>
    </div>

    <div class="table-wrap">
      <table class="compare-table">
        <thead>
          <tr>
            <th class="col-issue">Issue</th>
            <th class="col-lydia">
              <div class="col-lydia__inner">
                <img src="assets/Logo.png" alt="Lydia" class="col-logo" />
                <span>Lydia</span>
                <span class="col-badge col-badge--ind">Libertarian</span>
              </div>
            </th>
            <th class="col-other">Haley Stevens<br><small>Democrat</small></th>
            <th class="col-other">Abdul El-Sayed<br><small>Democrat</small></th>
            <th class="col-other">Mike Rogers<br><small>Republican</small></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows" class="compare-row">
            <td class="cell-issue">{{ row.issue }}</td>
            <td class="cell-lydia" [class]="'cell-lydia--' + row.lydiaClass">{{ row.lydia }}</td>
            <td class="cell-other">{{ row.stevens }}</td>
            <td class="cell-other">{{ row.elSayed }}</td>
            <td class="cell-other">{{ row.rogers }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="disclaimer">
      Candidate positions sourced from official campaign websites as of March 2026. Positions may change.
      Lydia's positions reflect her official platform at <a routerLink="/issues">lydialynnchristensen.com/issues</a>.
    </p>

    <div class="compare-cta">
      <h2>The Choice is Clear</h2>
      <p>No party. No corporate donors. Just Michigan.</p>
      <div class="compare-cta__buttons">
        <a routerLink="/issues" class="btn-primary">Explore Lydia's Full Platform</a>
        <a routerLink="/donate" class="btn-secondary">Support the Campaign</a>
      </div>
    </div>

  </div>
</section>
